import React from 'react';
import cm from 'classnames';

import { THUMBNAIL_RATIO } from 'constants/params';
import { useAppDispatch } from 'store/store-hooks';
import { setHideTooltipListener } from 'components/app/_mediator/app.slice';
import styles from './_track-clip.module.scss';

const generateDataUrl = () => {
  const canvas = document.createElement('canvas');
  canvas.width = 12;
  canvas.height = canvas.width / THUMBNAIL_RATIO;
  const context = canvas.getContext('2d');
  context!.fillStyle = 'grey';
  context!.fillRect(0, 0, canvas.width, canvas.height);
  return canvas.toDataURL();
};

const CLIP_RATIO = generateDataUrl();

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const ClipRatioContainer = ({ className, children }: Props) => {
  const dispatch = useAppDispatch();
  return (
    <div className={cm(styles.RatioContainer, className)} onClick={() => dispatch(setHideTooltipListener())}>
      <img src={CLIP_RATIO} className={styles.RatioContainer__ratio} />
      <div className={styles.RatioContainer__container}>{children}</div>
    </div>
  );
};
